import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const routes =[
  {
    path: '/',
    name: 'Home',
    // 路由守卫
    // meta: { requireAuth: true },
    component:resolve => require(['@/pages/Home'],resolve)//路由按需加载
  },
  //列表
  {
    path: '/List',
    name: 'List',
    component:resolve => require(['@/pages/List'],resolve)
  },
  //详情
  {
    path: '/Detail',
    name: 'Detail',
    component:resolve => require(['@/pages/Detail'],resolve)
  },
  //单页新闻
  {
    path: '/InfoShow',
    name: 'InfoShow',
    component:resolve => require(['@/pages/InfoShow'],resolve)
  },
  //录取查询
  {
    path: '/Enrollquery',
    name: 'Enrollquery',
    component:resolve => require(['@/pages/Enrollquery'],resolve)
  },
  {
    path: '/Campusmap',
    name: 'Campusmap',
    component:resolve => require(['@/pages/Campusmap'],resolve)
  },
  //登录
  {
    path: '/Login',
    name: 'Login',
    component:resolve => require(['@/pages/login/Login'],resolve)
  },
  //新生预报道说明
  {
    path: '/ForecastExplain',
    name: 'ForecastExplain',
    component:resolve => require(['@/pages/forecast/ForecastExplain'],resolve)
  },
  //新生预报道 个人基本信息
  {
    path: '/BaseInfo',
    name: 'BaseInfo',
    component:resolve => require(['@/pages/forecast/BaseInfo'],resolve)
  },
  //新生预报道 家庭信息
  {
    path: '/FamilyInfo',
    name: 'FamilyInfo',
    component:resolve => require(['@/pages/forecast/FamilyInfo'],resolve)
  },
  //新生预报道 缴费信息查看
  {
    path: '/PaymentInfo',
    name: 'PaymentInfo',
    component:resolve => require(['@/pages/forecast/PaymentInfo'],resolve)
  },
  //新生预报道  绿色通道
  {
    path: '/GreenRoad',
    name: 'GreenRoad',
    component:resolve => require(['@/pages/forecast/GreenRoad'],resolve)
  },
  //新生预报道  其他信息
  {
    path: '/OtherInfo',
    name: 'OtherInfo',
    component:resolve => require(['@/pages/forecast/OtherInfo'],resolve)
  },
  //新生预报道  行程信息
  {
    path: '/TravelInfo',
    name: 'TravelInfo',
    component:resolve => require(['@/pages/forecast/TravelInfo'],resolve)
  },
  //新生预报道  确认信息
  {
    path: '/SureInfo',
    name: 'SureInfo',
    component:resolve => require(['@/pages/forecast/SureInfo'],resolve)
  },
  //班级成员信息
  {
    path: '/ClassmatesInfo',
    name: 'ClassmatesInfo',
    component:resolve => require(['@/pages/forecast/ClassmatesInfo'],resolve)
  },
 {//页面找不到
  path: '/NotFound',
  name: 'NotFound',
  component: resolve => require(['@/pages/NotFound'], resolve),
},
 {//400
  path: '/NotFound4',
  name: 'NotFound4',
  component: resolve => require(['@/pages/NotFound4'], resolve),
},
 {//500
  path: '/NotFound5',
  name: 'NotFound5',
  component: resolve => require(['@/pages/NotFound5'], resolve),
}
]

const router =new Router({
  // mode:'history',
  routes ,
  // base: "/" + document.location.pathname.split('/')[1] + "/"      
});

// 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到错误页面
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next('/NotFound4') 
  }else {
    next() // 如果匹配到正确跳转
  }
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js